import React from 'react'

const Heading = ({title}) => {
  return (
    <h1 className='font-dm md:text-2xl md:text-[39px] font-bold mb-6 md:mb-12'>{title}</h1>
  )
}

export default Heading